
import { dates, datesFirstCaps, easternTimeOffset, months } from '../constants/dates';
import { addDays, differenceInDays, format } from 'date-fns';
import { getTwoDigits } from '../components/SpecialDayOff/SpecialDayOffHelper';
import { formatNumToTime } from './timeHelpers';

export const datesNumToName = (num: String | Number, offset = 0, dateArray = dates) => {
  if (num === undefined) {
    return;
  }
  const dateNum = num.toString();
  let formatedNum = parseInt(dateNum);
  formatedNum = formatedNum + offset;
  return dateArray.filter((_, i) => (i + 1) === formatedNum)[0];
};

export const easternTime = (passDay = null as null | Date) => {
  let date = passDay ? new Date(passDay) : new Date();
  let utc = date.getTime() + (date.getTimezoneOffset() * 60000);
  return new Date(utc + (3600000*easternTimeOffset));
};
// TODO: Need to switch to below function and remove dependency of easternTime
export const getEasternTime = (passDay = null as null | string) => {
  const utcStringDate = passDay ? getUtcDate(passDay) : new Date();
  const dateObject = new Date(utcStringDate).toLocaleString("en-US", {
    timeZone:"Canada/Eastern",
  });
  return new Date(dateObject);
}

export const getUtcDate = (date: string) => {
  const utcObj = date.split(/[/\s:]/);
  let utcDateObj = utcObj.map((item,index) => index === 1? (Number(item)-1): Number(item));
  return new Date(Date.UTC(utcDateObj[0],utcDateObj[1],utcDateObj[2],utcDateObj[3],utcDateObj[4],utcDateObj[5] ?? 0)).toUTCString();
}

export const datesNameToNum = (name: String) => {
  if (!name) {
    return false;
  }
  return dates.map((month, i) => month === name ? i + 1 : false).filter(f => f)[0];
};

export const getMonth = (date: string) => {
  return datesNameToNum(date.split(' ')[0]);
}

export const getYear = (date: string) => {
  return parseInt(date.split(' ')[1]);
}

export const getFormattedMonth = (month: number, year: number) => {
  const date = new Date(year, month - 1);
  return format(date, 'MMM yyyy').toUpperCase();
};

export const getNextMonth = () => {
  const currentMonth = new Date();
  const nextMonth = (new Date().getMonth() === 11) ?
    new Date(currentMonth.getFullYear() + 1, 0, 1) :
    new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1);
  return format(nextMonth, 'MMM yyyy').toUpperCase();
};

export const getCurrentMonth = () => {
  return format(new Date(), 'MMM yyyy').toUpperCase();
};

interface monthDate {
  month: number
  year: number
}
export const generateNextNMonths = (nMonths: number = 12, monthOffset: number = 1) => {
  const currDate = getEasternTime();
  const currYear = currDate.getFullYear();
  const nextMonth = currDate.getMonth() + monthOffset;
  let monthsArr = [] as monthDate[]
  let months = Array.from(Array(nMonths).keys()).map(f => f + 1);
  months.forEach((m) => {
    if (nextMonth + m > 12) {
      monthsArr.push({
        month: nextMonth + m - 12,
        year: currYear + 1
      });
    } else {
      monthsArr.push({
        month: nextMonth + m,
        year: currYear
      });
    }
  });
  return monthsArr.map(m => ({ ...m, month: datesNumToName(m.month.toString()), monthNumber: m.month }));
}

export const generatePrevNMonths = (nMonths: number = 13, monthOffset: number = 1, fromDate?: Date) => {
  const currDate = fromDate ? fromDate : getEasternTime();
  const currYear = currDate.getFullYear();
  const prevMonth = currDate.getMonth() + monthOffset;
  let monthsArr = [] as monthDate[];

  let months = Array.from(Array(nMonths).keys()).map(f => f + 1);
  months.forEach((m) => {
    if(prevMonth - m > 12) {
      monthsArr.push({
        month: 1,
        year: currYear + 1
      });
    }
    else {
      if (prevMonth - m < 1) {
        monthsArr.push({
          month: prevMonth - m + 12,
          year: currYear - 1
        });
      } else {
        monthsArr.push({
          month: prevMonth - m,
          year: currYear
        });
      }
    }    
  });

  return monthsArr.map(m => ({ ...m, month: datesNumToName(m.month.toString()), monthNumber: m.month }));
};


export const getWeekendDates = (startDate?: Date, endDate?: Date, offset =1) => {
  if (!startDate || !endDate) {
    return { weekday: [], weekend: [] };
  }
  let d = startDate ? new Date(startDate) : new Date();
  let end = new Date(endDate);
  d.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + offset);
  end.setDate(end.getDate() + offset);
  let weekend = new Array<Date>();
  let weekDay = new Array<Date>();

  while (d.getTime() <= end.getTime()) {
    if (d.getDay() === 6 || d.getDay() === 0) {
      weekend.push(new Date(d));
    } else {
      weekDay.push(new Date(d));
    }
    d.setDate(d.getDate() + 1);
  }
  return { weekday: weekDay, weekend: weekend };
};


export const stringToDate = (month, date, year, monthOffset = 0) => {
  let m = dates.map((mo, i) => mo === month.toUpperCase() ? i + 1 + monthOffset : 0).filter(f => f)[0];
  let day = new Date(`${year}-${m}-${date}`);
  day.setHours(0, 0, 0, 0);
  return day;
}

export const apiDateToDate = (apiDate, time ='00:00:00') => {
  return new Date(`${apiDate}T${time}`) || new Date('0');
}

  // August 24th
export  const stringToMonthDate = (date) => {
    if(!date) { 
      return;
    }
    return( `${months[date.getMonth()]} ${ordinalNumber(date.getDate())}` )
  }

export const getDate = (date: string) => {
  const dateArray = date.split('-');
  return (new Date(parseInt(dateArray[0]), parseInt(dateArray[1])-1, parseInt(dateArray[2])));
}

export const ordinalNumber = (param: string | number) => {
  let index;
  let num = typeof param === 'string'? parseInt(param) : param
  if (num <= 0) {
    index = 4;
  } else if ((num > 3 && num < 21) || num % 10 > 3) {
    index = 0;
  } else {
    index = num % 10;
  }
  return ` ${param}${['th', 'st', 'nd', 'rd', ''][index]}`;
}


 

export const getWeekday = (date: string) => {
  const weekday = getDate(date).getDay();
  return  weekday === 0 ? 7 : weekday;
}

export const getMonthDay = (date: string) => {
  return  format(getDate(date), 'MMM dd');
}
export const numberShorten = (apidata, digits=1 ) => {
  let x = (''+apidata).length
  digits = Math.pow(10,digits);
  if(x === 9){ x = 6 } // to eliminate 379180047 => 0.4G
  x-= x%3;
  return Math.round(apidata*digits/Math.pow(10,x))/digits+" KMGTPE"[x/3];
}

// to format date in YYYY/MM/DD format
export const formatDate = (date) => {
  if (!date) {
    return "";
  }
  let d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('/');
}

// to return array of number of days between start and end date of a Calendar
export const getNumberOfDays = (start: Date, end: Date) => {
  if (!start || !end) {
    return [];
  }
  let arr: string[] = [];
  let dt = new Date(start);
  while (dt <= end) {
    arr.push(formatDate(new Date(dt)));
    dt.setDate(dt.getDate() + 1);
  }
  return arr;
};

export const timezoneDateFormatter = (date: string) => {
  if (!date) {
    return '-';
  }
  let d = new Date(date);
  let month = datesNumToName(d.getMonth() + 1);
  let h = d.getHours();
  let m = d.getMinutes();
  let time = `${h < 10 ? `0${h}` : h}:${m < 10 ? `0${m}` : m}`;
  return `${month} ${d.getDate()} ${d.getFullYear()} @ ${time} EST`;
};


export const apiStringToDate = (apiDate, time ='00:00:00')=> {
  return new Date(`${apiDate}T${time}`) || new Date('0');
}
export const checkPrevMonthSelection = (selectedDate, dateOptions: string[]) => {
  if (!selectedDate || dateOptions.length === 0) {
    return false;
  }
  if(!dateOptions) {
    let selectedMonth = new Date("1 " + selectedDate);
    let currentMonth = new Date("1 " + getCurrentMonth());
    if(selectedMonth < currentMonth){
      return true;
    }
    return false;
  }

  return selectedDate !== dateOptions[0] && selectedDate !== dateOptions[1];
}

export const getDateInWeekDayMonthDateFormat = (date) => {
  if(!date){
    return "";
  }

  const weekday = date.toLocaleString("default", { weekday: "short" });
  const month = date.toLocaleString("default", { month: "short" });
  const dateNumber = date.getDate() < 10 ? `0${date.getDate()}`: date.getDate();
  return weekday+", "+month+" "+dateNumber;
}

export const getPreviousDate: any = (date) => {
  const previousDate = new Date(date);
  return new Date(previousDate.setDate(previousDate.getDate() - 1));
}

export const getNextDate: any = (date) => {
  const nextDate = new Date(date);
  return new Date(nextDate.setDate(nextDate.getDate() + 1));
}

// to get a list of previous days until Monday
export const getPreviousDays = (daysArr, startDate) => { 
  if(!daysArr && !startDate){
    return;
  } 
  const startDateIndex = new Date(startDate+" 00:00").getDay() === 0 ? 7 : new Date(startDate+" 00:00").getDay();
  let day = startDate;
  for(let i = startDateIndex; i > 0; i--) {
    day = formatDate(getPreviousDate(day+" 00:00"));
    daysArr.unshift(day);
  }
  return daysArr;
}


// to get a list of next days until Sunday
export const getNextDays = (daysArr, endDate) => {  
  if(!daysArr && !endDate){
    return;
  } 
  const endDateIndex = new Date(endDate+" 00:00").getDay() === 0 ? 7 : new Date(endDate+" 00:00").getDay();
  let day = endDate;
  for(let i = endDateIndex; i < 6; i++) {
    day = formatDate(getNextDate(day+" 00:00"));
    daysArr.push(day);
  }
  return daysArr;
}

export const getDateAndTimeFormat = () => {
  const time = getEasternTime().getHours() + ':' + ("0" + (getEasternTime().getMinutes())).slice(-2) + ':' + ("0" + (getEasternTime().getSeconds())).slice(-2);
  const date = getEasternTime().getFullYear() + '-' + ("0" + (getEasternTime().getMonth() + 1)).slice(-2) + '-' + ("0" + (getEasternTime().getDate())).slice(-2);
  return date + " " + time;
}

export const getEasternDateTime = (utcDate: Date) => {
  const dateObject = new Date(utcDate).toLocaleString('en-US', {
    timeZone: 'Canada/Eastern'
  });
  return new Date(dateObject).toString();
}

export const formatDateToDash = (date) => {
  if (!date) {
    return "";
  }
  let d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}

export const getPreviousWeek = (daysArr, startDate) => {
  let dates: Array<string> = [];
  for (let i=1; i<=7; i++) {
      let date = new Date(startDate);
      date.setDate(date.getDate() - i);
      dates.push(formatDate(new Date(date)));
  }
  dates.forEach(date => daysArr.unshift(date));
}

export const getTimeHrMin = (date) =>{
  if(!date) return "";
  const getTwoDigits = (param) => param? ('0' + param).slice(-2) : '00';
  const time = `@ ${getTwoDigits(date.getHours())}:${getTwoDigits(date.getMinutes())} ET`;
  return time;
}

export const getMonthDayYear = (date) => {
  if (!date) return '';
  return datesFirstCaps[new Date(date).getMonth()] + " " + getTwoDigits(new Date(date).getDate()) + ", " + new Date(date).getFullYear();
}

export const convertFromStringToDate = (date) => {
  if (!date) return '';
  let dateComponents = date.split('T');
  let datePieces = dateComponents[0].split("-");
  return(new Date(datePieces[2], (datePieces[1] - 1), datePieces[0]));
}

export const convertToDateObject = (date: string, time: string | number | undefined) => {
    const formattedTime = typeof(time) === 'string' ? time : formatNumToTime(time);
    return new Date(`${date} ${formattedTime}`);
}

export const convertToDateTime = (date: string, time: string | number | undefined) => {
  return convertToDateObject(date, time).getTime();
}
export const convertToMonthName=(monthNumber)=> {
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return date.toLocaleString('en-US', {month: 'short' }).toUpperCase();
}

export const getMiddleDate = (startDate: Date, endDate: Date) => {
  const diff = differenceInDays(endDate, startDate);
  return addDays(startDate, Math.floor(diff / 2));
}